<template>
  <div class="relative">
    <div class="absolute top14rem left-0 mob-hidden">
      <img
        src="../../../../../assets/images/bg-des/bgd6.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="container mb-24">
      <!--<div class="relative mt-6 mb-12">
        <div class="absolute left-4 top-4">
          <feather-icon icon="SearchIcon" class="text-primary" />
        </div>
        <b-input
          placeholder="Search for anything"
          class="w-full font-medium bannertext-input fsize16 border-2 shadow-md"
          v-model="search"
          @keyup="searchData()"
        />
      </div>-->
      <section class="" v-if="wishlistData.length == 0">
        <NoData />
      </section>
      <section
        class="grid lg:grid-cols-3 md:grid-cols-2 gap-cols-1 gap-8 pt-5 pb-10"
        v-else
      >
        <b-card
          class="mb-2 border-0"
          no-body
          v-for="(item, index) in wishlistData"
          :key="index"
        >
          <div v-for="(items, index) in item.course" :key="index">
            <div class="overflow-hidden hover-rad-tr relative">
              <img
                :src="`${$imageURL}/${items.icone}`"
                alt="course-img"
                class="w-full rounded-tl-lg rounded-tr-lg img-zoom card-topimg-h228 object-cover"
              />

              <div class="card-rating">
                {{ items.rating }}<i class="fa fa-star text-warning"></i>
              </div>
              <!-- <a href="#" class="card-bookmark"
            ><feather-icon icon="BookmarkIcon"
          /></a> -->
            </div>
            <b-card-text class="p-6">
              <div class="row">
                <div class="col-6">
                  <p class="font-semibold fsize16 sm-fsize12">
                    {{ items.chapter.length }} chapters
                  </p>
                </div>
                <div class="col-6 text-right">
                  <p class="font-semibold fsize16 sm-fsize12">
                    {{ items.duration }} Hrs
                  </p>
                </div>
              </div>
              <h4 class="font-bold fsize20 sm-fsize16 mt-3 mb-6">
                {{ items.name }}
              </h4>
              <div class="row">
                <div class="col-6">
                  <p class="font-semibold fsize18 sm-fsize12 text-black">
                    ₹ {{ items.discountPrice }}
                  </p>
                </div>
                <div class="col-6 flex justify-end">
                  <div class="cust-tooltip-ui flex items-center">
                    <a href="#"
                      ><i
                        class="fa fa-shopping-cart"
                        @click="addToCart(items)"
                      ></i
                    ></a>
                    <span class="tooltiptext-ui">Add to Cart</span>
                  </div>
                  <div class="cust-tooltip-ui flex items-center">
                    <feather-icon
                      icon="Trash2Icon"
                      svgClasses="w-5 h-5"
                      class="ml-2 cursor-pointer text-danger flex items-center"
                      @click="removeWishlist(item)"
                    />
                    <span class="tooltiptext-ui">Remove from Wishlist</span>
                  </div>
                </div>
              </div>
            </b-card-text>
          </div>
        </b-card>
      </section>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NoData from "../../NoData.vue";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      courses: [
        {
          id: "01",
          img: require("@/assets/images/courses/1.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
        {
          id: "02",
          img: require("@/assets/images/courses/2.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
        {
          id: "03",
          img: require("@/assets/images/courses/3.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
        {
          id: "04",
          img: require("@/assets/images/courses/4.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
        {
          id: "05",
          img: require("@/assets/images/courses/5.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
        {
          id: "06",
          img: require("@/assets/images/courses/1.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99",
        },
      ],
      wishlistData: [],
      student_id: "",
      search: "",
      course: "",
    };
  },
  methods: {
    async getAllStudents() {
      const data = await this.$store.dispatch(
        "student/getsinglestudent",
        this.userData.student._id
      );

      this.wishlistData = this.get_singlestudent.wishlist;
    },
    removeWishlist(item) {
      // console.log(item._id);
      if (item._id.length != 0) {
        this.$swal({
          title: "Are you sure?",

          text: "You won't be able to revert this!",

          icon: "warning",

          showCancelButton: true,

          confirmButtonColor: "#830c81",

          cancelButtonColor: "#d33",

          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.value) {
            const index = this.wishlistData.indexOf(item);
            // console.log(index);
            if (index > -1) {
              this.wishlistData.splice(index, 1);
              // console.log(this.wishlistData);
            }
            // this.$swal("Removed!", "Item has been removed.", "success");
            this.$swal.fire({
              title: "Removed!",
              text: "Item has been removed.",
              icon: "success",
              confirmButtonColor: "#830c81",
            });

            const { data } = this.$store.dispatch("wishlist/removeWishlist", {
              _id: item._id,
              wishlist: item._id,
              student: this.userData.student._id,
            });
            this.getAllStudents();
            this.getAllStudents();
          }
        });
      }
    },
    async addToCart(item) {
      // console.log(item);
      const course = item;

      try {
        const { data } = this.$store.dispatch("cart/AddCart", {
          type: "Course",
          course: course._id,
        });
        // console.log(data);
        this.$swal.fire({
          title: "Added To Cart!!!",

          text: "Course added to your learning plan!",

          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
      } catch (err) {
        this.$swal.fire({
          title: "Please Check Cart",

          text: "Item is already in cart!",

          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
      }
    },
  },
  mounted() {
    this.getAllStudents();
    // this.getWishlist();
  },
  computed: {
    // ...mapState("eLearning", ["wishlist"]),
    ...mapState("auth", ["userData"]),
    ...mapState("student", ["students"]),
    // ...mapState("eLearning",["course"])
    ...mapState("student", ["get_singlestudent"]),

    filterData() {
      const search = this.search.toLowerCase();

      if (!search) return this.wishlistData;

      this.wishlistData.filter((item) => {
        return item.course.filter((data) => {
          return data.name.toLowerCase().includes(search);
        });
      });

      // return this.wishlistData.filter((data)=>{

      //   return data.course.some((item)=>{
      //     item.name.toLowerCase().includes(this.search.toLowerCase())
      //   })
      // })
    },
  },
};
</script>
